import { container } from '@/container';

export const PrintCloverReceiptMixin = {
    computed: {
        /**
         * @return {boolean}
         */
        hasCloverPayments() {
            return !!this.order.payments.find((p) => p.isClover());
        },
    },

    methods: {
        async printCloverReceipts() {
            this.isPrinting = true;
            try {
                await container.cloverDriver.generateReceipts(this.order.payments);
            } catch (e) {
                container.toastFactory.errorTop('CLOVER.PRINT_ERROR', e.message);
            }
            this.isPrinting = false;
        },
    },
};
